/**
 * store application
 * This file helps the application to communicate with all the components
 * store is an object that maintains a shared state for all applications and acts as an intermediary between the components
 * The store can be access from whatever places in the application
 * To works needs 4 functions: subscribe, dispatch, getState and reducer
 */
import { createBrowserHistory } from "history";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { createStore, applyMiddleware, compose } from "redux";
import reducers from "./MainReducers";
import createSagaMiddleware from "redux-saga";
import { combinedSagas } from "./MainSaga";

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

export const history = createBrowserHistory();

/*const logger = store => next => action => {
    // console.log('dispatching', action);
    let result = next(action);
    // console.log('next state', store.getState());
    return result;
};*/

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose;

const enhancer = composeEnhancers(
  applyMiddleware(
    routerMiddleware(history), // for dispatching history actions
    sagaMiddleware
  )
  // other store enhancers if any
);

const store = createStore(
  connectRouter(history)(reducers), // new root reducer with router state,
  enhancer
);

// run the sagas
combinedSagas(sagaMiddleware);

export default store;



// WEBPACK FOOTER //
// ./src/modules/Setup/Store.js